"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react/jsx-key */
var dx_react_grid_1 = require("@devexpress/dx-react-grid");
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var Input_1 = __importDefault(require("@material-ui/core/Input"));
var styles_1 = require("@material-ui/core/styles");
var DateRange_1 = __importDefault(require("@material-ui/icons/DateRange"));
var antd_1 = require("antd");
var moment_1 = __importDefault(require("moment"));
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
function DefaultDevExtremeGridComponents(_a) {
    var table = _a.table, _b = _a.defaultHiddenColumnNames, defaultHiddenColumnNames = _b === void 0 ? [] : _b, _c = _a.stringFields, stringFields = _c === void 0 ? [] : _c, _d = _a.withSelection, withSelection = _d === void 0 ? false : _d, _e = _a.groups, groups = _e === void 0 ? true : _e, _f = _a.filter, filter = _f === void 0 ? true : _f, _g = _a.pagination, pagination = _g === void 0 ? false : _g, _h = _a.allowHidingColumns, allowHidingColumns = _h === void 0 ? true : _h, columnExtensions = _a.columnExtensions, _j = _a.summaryColumn, summaryColumn = _j === void 0 ? true : _j, pageSize = _a.pageSize;
    var FilterIcon = function (_a) {
        var type = _a.type, restProps = __rest(_a, ["type"]);
        if (type === "month")
            return (0, jsx_runtime_1.jsx)(DateRange_1.default, __assign({}, restProps));
        return (0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.TableFilterRow.Icon, __assign({ type: type }, restProps));
    };
    var styles = function (theme) { return ({
        root: {
            margin: theme.spacing(1),
        },
        numericInput: {
            fontSize: "14px",
            width: "100%",
        },
    }); };
    var CurrencyEditorBase = function (_a) {
        var value = _a.value, onValueChange = _a.onValueChange, classes = _a.classes;
        var handleChange = function (event) {
            var targetValue = event.target.value;
            if (targetValue.trim() === "") {
                onValueChange(undefined);
                return;
            }
            onValueChange(parseInt(targetValue, 10));
        };
        return ((0, jsx_runtime_1.jsx)(Input_1.default, { type: "number", classes: {
                input: classes.numericInput,
                root: classes.root,
            }, fullWidth: true, value: value === undefined ? "" : value, inputProps: { min: 0, placeholder: "Filter..." }, onChange: handleChange }));
    };
    var StyledCurrencyEditor = (0, styles_1.withStyles)(styles)(CurrencyEditorBase);
    // Adapter that strips the classes prop so the grid only sees ValueEditorProps
    var CurrencyEditor = function (props) {
        return (0, jsx_runtime_1.jsx)(StyledCurrencyEditor, __assign({}, props));
    };
    var DateEditorBase = function (_a) {
        var value = _a.value, onValueChange = _a.onValueChange, disabled = _a.disabled;
        var handleChange = function (event) {
            var value = event;
            onValueChange(value.startOf("day"));
        };
        return ((0, jsx_runtime_1.jsx)(antd_1.DatePicker, { format: "DD/MM/YYYY", value: value !== null && value !== void 0 ? value : null, onChange: handleChange }));
    };
    var dateFilterPredicate = function (value, filter, row) {
        if (!filter)
            return true;
        var date = (0, moment_1.default)(value).startOf("day");
        var filterDate = (0, moment_1.default)(filter.value).startOf("day");
        switch (filter.operation) {
            case "lessThanOrEqual":
                return date.isSameOrBefore(filterDate);
            case "greaterThanOrEqual":
                return date.isSameOrAfter(filterDate);
            case "equal":
                return date.isSame(filterDate);
            default:
                return dx_react_grid_1.IntegratedFiltering.defaultPredicate(value, filter, row);
        }
    };
    var filteringColumnExtensions = [
        { columnName: "expiryDate", predicate: dateFilterPredicate },
        { columnName: "createdAt", predicate: dateFilterPredicate },
        { columnName: "importedAt", predicate: dateFilterPredicate },
    ];
    return [
        (0, jsx_runtime_1.jsx)(dx_react_grid_1.DataTypeProvider, { for: stringFields, availableFilterOperations: [
                "startsWith",
                "endsWith",
                "contains",
                "equal",
            ] }, -1),
        (0, jsx_runtime_1.jsx)(dx_react_grid_1.DataTypeProvider, { for: ["expiryDate", "createdAt", "importDate"], availableFilterOperations: [
                "equal",
                "lessThanOrEqual",
                "greaterThanOrEqual",
            ], editorComponent: DateEditorBase }, -3),
        (0, jsx_runtime_1.jsx)(dx_react_grid_1.DataTypeProvider, { for: ["quantity", "expiredAfter"], availableFilterOperations: [
                "equal",
                "lessThan",
                "lessThanOrEqual",
                "greaterThan",
                "greaterThanOrEqual",
            ], editorComponent: CurrencyEditor }, -4),
        filter && (0, jsx_runtime_1.jsx)(dx_react_grid_1.FilteringState, { defaultFilters: [] }, 9),
        (0, jsx_runtime_1.jsx)(dx_react_grid_1.IntegratedFiltering, { columnExtensions: filteringColumnExtensions }),
        (0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.DragDropProvider, {}, 1),
        withSelection && (0, jsx_runtime_1.jsx)(dx_react_grid_1.IntegratedSelection, {}, 2),
        (0, jsx_runtime_1.jsx)(dx_react_grid_1.SortingState, { defaultSorting: [] }, 3),
        (0, jsx_runtime_1.jsx)(dx_react_grid_1.IntegratedSorting, {}, 4),
        groups && (0, jsx_runtime_1.jsx)(dx_react_grid_1.GroupingState, { defaultGrouping: [] }, 5),
        groups && (0, jsx_runtime_1.jsx)(dx_react_grid_1.IntegratedGrouping, {}, 6),
        pagination && ((0, jsx_runtime_1.jsx)(dx_react_grid_1.PagingState, { defaultCurrentPage: 0, pageSize: pageSize !== null && pageSize !== void 0 ? pageSize : 25 }, 7)),
        pagination && (0, jsx_runtime_1.jsx)(dx_react_grid_1.IntegratedPaging, {}, 8),
        (0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.Table, { cellComponent: NewCellComp, rowComponent: function (props) { return (0, jsx_runtime_1.jsx)(NewRowComp, __assign({}, props, { table: table })); }, columnExtensions: columnExtensions }, 11),
        summaryColumn && ((0, jsx_runtime_1.jsx)(dx_react_grid_1.SummaryState, { totalItems: [
                { columnName: "NO", type: "count" },
                { columnName: "quantity", type: "sum" },
                { columnName: "totalPrice", type: "sum" },
            ] })),
        summaryColumn && (0, jsx_runtime_1.jsx)(dx_react_grid_1.IntegratedSummary, {}),
        summaryColumn && (0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.TableSummaryRow, {}),
        withSelection && (0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.TableSelection, { showSelectAll: true }, 12),
        filter && ((0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.TableFilterRow, { rowComponent: function (props) { return (0, jsx_runtime_1.jsx)(RowCompWithBackgroundColor, __assign({}, props)); }, showFilterSelector: true, iconComponent: FilterIcon }, 13)),
        pagination && (0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.PagingPanel, {}, 14),
        (0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.TableHeaderRow, { showSortingControls: true }, 15),
        allowHidingColumns && ((0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.TableColumnVisibility, { defaultHiddenColumnNames: defaultHiddenColumnNames }, 16)),
        groups && (0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.TableGroupRow, {}, 17),
        (allowHidingColumns || groups) && (0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.Toolbar, {}, 18),
        allowHidingColumns && (0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.ColumnChooser, {}, 19),
        groups && (0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.GroupingPanel, {}, 20),
    ];
}
exports.default = DefaultDevExtremeGridComponents;
var NewRowComp = function (_a) {
    var row = _a.row, children = _a.children, tableRow = _a.tableRow, table = _a.table;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var props = { row: row, children: children, tableRow: tableRow };
    var expiryDate = (0, moment_1.default)(row.expiryDate);
    var currentDate = (0, moment_1.default)();
    var monthsUntilExpiry = expiryDate.diff(currentDate, "months");
    return ((0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.Table.Row, __assign({}, props, { style: {
            backgroundColor: row.expiryDate
                ? monthsUntilExpiry <= 3
                    ? "#ff4d4f70"
                    : "none"
                : "none",
        }, onDoubleClick: table
            ? function () {
                navigate("/".concat(table, "/").concat(row.id));
            }
            : undefined })));
};
var RowCompWithBackgroundColor = function (_a) {
    var children = _a.children, tableRow = _a.tableRow;
    var props = { children: children, tableRow: tableRow };
    return ((0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.Table.Row, __assign({ row: tableRow.row }, props, { style: { backgroundColor: "#E8E7E6" } })));
};
var NewCellComp = function (props) {
    return (0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.Table.Cell, __assign({}, props, { style: { whiteSpace: "break-spaces" } }));
};
